import { SecondaryMarketPostEventTabType } from 'state/workspaces/model';

export type SecondaryMarketPostTradeWorkspaceActions =
  | SecondaryMarketPostTradeWorkspaceAddTab
  | SecondaryMarketPostTradeWorkspaceRemoveTab;

export function secondaryMarketPostEventWorkspaceAddTab(
  tabId: string,
  orderId: string,
  tabType: SecondaryMarketPostEventTabType,
) {
  return { type: 'SECONDARY_MARKET_POSTEVENT_WORKSPACE_ADD_TAB' as const, tabId, orderId, tabType };
}
export type SecondaryMarketPostTradeWorkspaceAddTab = ReturnType<typeof secondaryMarketPostEventWorkspaceAddTab>;

export function secondaryMarketPostEventWorkspaceRemoveTab(tabId: string, tabType: SecondaryMarketPostEventTabType) {
  return { type: 'SECONDARY_MARKET_POSTEVENT_WORKSPACE_REMOVE_TAB' as const, tabId, tabType };
}
export type SecondaryMarketPostTradeWorkspaceRemoveTab = ReturnType<typeof secondaryMarketPostEventWorkspaceRemoveTab>;
